export const SUSPENDED_MESSAGE_DISPLAYED = 'SUSPENDED_MESSAGE_DISPLAYED';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const NOTIFICATIONS_POSITION_UPDATED = 'NOTIFICATIONS_POSITION_UPDATED';
export const GET_APP_CONFIG = 'GET_APP_CONFIG';
export const SET_IS_NOT_NEW_USER = 'SET_IS_NOT_NEW_USER';
export const SET_MEDIA_SIZE = 'SET_MEDIA_SIZE';
export const SET_NOTIFICATIONS_SUSPENDED = 'SET_NOTIFICATIONS_SUSPENDED';
